import { EndpointError } from '../client/response';

/**
 * Whether the API answered 404. What that means depends on what was asked —
 * the entity was already deleted, or it never existed in the first place — so
 * callers decide whether it is the answer they wanted or a failure.
 */
export function isNotFoundError(error: unknown): boolean {
  return error instanceof EndpointError && error.response.status === 404;
}
